import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GLMMaterialDesignModule} from '../../_components/material-design/material-design.module';
import {DynamicBarModule} from '../../_components/dynamic-bar/dynamic-bar.module';
import {CustomPipesModule} from '../../_pipes/custom-pipes.module';
import {RouterModule} from '@angular/router';
import {NotificacionesComponent} from "./notificaciones.component";
import {NotificacionComponent} from "./notificacion/notificacion.component";


@NgModule({
  imports: [CommonModule,
    GLMMaterialDesignModule,
    DynamicBarModule,
    CustomPipesModule,
    RouterModule
  ],
  exports: [
    NotificacionesComponent
  ],
  declarations: [
    NotificacionesComponent,
    NotificacionComponent
  ],
  providers: [],
})
export class NotificacionesModule {
}
